export default __webpack_public_path__ + "static/media/sd-banner-5.3f25adf9.jpg";